import { useState } from "react"
import { Link, NavLink } from "react-router-dom"
import { FaBars, FaTimes, FaWhatsapp } from "react-icons/fa"

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false)

  const navLinks = [
    { name: "Accueil", path: "/" },
    { name: "Catégories", path: "/categories" },
    { name: "Produits", path: "/produits" },
    { name: "À Propos", path: "/a-propos" },
    { name: "Contact", path: "/contact" },
  ]

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm">
      <nav
        className="container mx-auto px-4 lg:px-8"
        aria-label="Navigation principale"
      >
        <div className="flex items-center justify-between h-20">

          {/* Logo */}
{/* Logo + Nom */}
<Link
  to="/"
  className="flex items-center gap-3"
  aria-label="Retour à l'accueil"
>
  <img
    src="/images/favicon.jpg"
    alt="Khenissi Textile - Grossiste textile et mercerie"
    className="h-10 md:h-12 w-auto"
  />

  <div>
    <h1 className="text-base md:text-xl font-bold text-gray-900 leading-none">
      KHENISSI
    </h1>

    <p className="text-[10px] md:text-xs text-gray-500 uppercase tracking-wide mt-1">
      Textile & Mercerie
    </p>
  </div>
</Link>

          {/* Desktop Menu */}
          <ul className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <li key={link.path}>
                <NavLink
                  to={link.path}
                  className={({ isActive }) =>
                    `font-medium transition-colors duration-300 ${
                      isActive
                        ? "text-black"
                        : "text-gray-600 hover:text-black"
                    }`
                  }
                >
                  {link.name}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* WhatsApp */}
          <a
            href="https://wa.me/21628718432"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-5 py-3 rounded-lg transition"
            aria-label="Contact WhatsApp"
          >
            <FaWhatsapp size={20} />
            WhatsApp
          </a>

          {/* Mobile Button */}
          <button
            className="lg:hidden text-2xl"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Ouvrir le menu"
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-300 ${
            isOpen ? "max-h-96 pb-6" : "max-h-0"
          }`}
        >
          <ul className="flex flex-col gap-4 pt-4">
            {navLinks.map((link) => (
              <li key={link.path}>
                <NavLink
                  to={link.path}
                  onClick={() => setIsOpen(false)}
                  className="block text-gray-700 font-medium hover:text-black"
                >
                  {link.name}
                </NavLink>
              </li>
            ))}
          </ul>

          <a
            href="https://wa.me/21628718432"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 bg-green-500 text-white px-5 py-3 rounded-lg"
          >
            <FaWhatsapp />
            WhatsApp
          </a>
        </div>
      </nav>
    </header>
  )
}